import { styled } from '@mui/material/styles'
import { Box, BoxProps } from '@mui/material'
import { Content, HeaderMenuButton } from '@/components/ui'

import logo from '@/images/logo-black.png'
import loginBackgroundImage from '@/images/boxes-mobile-bg.jpg'
import Image from 'next/image'
import React from 'react'
import { useAuth, useHeader } from 'src/hooks'
import { MenuModal } from '../menu/Modal'

const BackgroundImage = styled(Image)`
  object-fit: cover;
`

const Logo = styled(Image)`
  position: absolute;
  top: 50%;
  left: 24px;
  transform: translateY(-50%);
`

const MenuButtonContainer = styled(Box)`
  position: absolute;
  right: 24px;
  top: 50%;
  transform: translateY(-50%);
  color: white !important;
`

export const MobileContent = styled(Content)<BoxProps & { ref?: any }>`
  position: relative;

  ${({ theme }) => theme.breakpoints.only('xs')} {
    border-radius: 12px 12px 0 0;
    background-color: ${({ theme }) => theme.palette.common.white};
    top: -12px;
  }
`

interface Props {
  logoSize?: {
    width: number
    height: number
  }
  bgSize?: {
    height?: number
    top?: number
  }
}

export const MobileHeader: React.FC<Props> = ({ logoSize, bgSize }) => {
  const containerHeight = bgSize?.height || 84
  const logoWidth = logoSize?.width || 167
  const logoHeight = logoSize?.height || 36
  const { isAuthorized } = useAuth()
  const { isVisibleMenu, openMenu, closeMenu } = useHeader()

  return (
    <Box sx={{ width: '100%', height: containerHeight, position: 'relative' }}>
      <BackgroundImage
        fill
        src={loginBackgroundImage}
        alt="Charleston Wrap mobile background"
        style={{ top: bgSize?.top }}
      />
      <Logo src={logo.src} alt="Charleston Wrap logo" width={logoWidth} height={logoHeight} />
      {isAuthorized && (
        <MenuButtonContainer>
          <HeaderMenuButton color="white" onClick={openMenu} />
        </MenuButtonContainer>
      )}
      {isAuthorized && <MenuModal isVisible={isVisibleMenu} onClose={closeMenu} />}
    </Box>
  )
}
